import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import authen from './modules/authen'
import source from './modules/source'
Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        app,
        authen,
        source
    }
})
